import { ReactNode, useEffect, useState } from 'react';
import { Avatar, AvatarProps } from '@mui/material';

interface LoadAwareAvatarProps extends Omit<AvatarProps, 'srcSet'> {
  onLoad?: () => void;
  src: string;
  fallback?: ReactNode;
}

export const LoadAwareAvatar = ({ src, onLoad, fallback, ...props }: LoadAwareAvatarProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = src;

    const handleLoad = () => {
      setImageLoaded(true);
      if (onLoad) onLoad();
    };

    const handleError = () => setImageLoaded(false);

    img.addEventListener('load', handleLoad);
    img.addEventListener('error', handleError);

    return () => {
      img.removeEventListener('load', handleLoad);
      img.removeEventListener('error', handleError);
    };
  }, [src, onLoad]);

  return (
    <Avatar srcSet={imageLoaded ? src : undefined} {...props}>
      {fallback ?? null}
    </Avatar>
  );
};
